const AzoresIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110822)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20.0008C0 27.5817 4.21797 34.177 10.4348 37.569V2.43262C4.21797 5.82465 0 12.42 0 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M0 19.9995C0 29.24 6.26727 37.0155 14.7826 39.3105V0.688477C6.26727 2.98348 0 10.7589 0 19.9995Z"
        fill="#0052B4"
      />
      <path
        d="M7.17432 6.95703V10.2179C7.17432 11.8387 8.48822 13.1527 10.1091 13.1527C11.7299 13.1527 13.0438 11.8387 13.0438 10.2179V6.95703H7.17432Z"
        fill="#D80027"
      />
      <path
        d="M10.1092 11.4127C9.4499 11.4127 8.91357 10.8763 8.91357 10.217V8.69531H11.3049V10.217C11.3049 10.8763 10.7685 11.4127 10.1092 11.4127Z"
        fill="#F0F0F0"
      />
      <path
        d="M21.7388 20.869H16.5214C16.5214 19.9086 15.7427 19.1299 14.7822 19.1299C13.8218 19.1299 13.0431 19.9086 13.0431 20.869H7.82568C7.82568 21.8296 8.66232 22.6082 9.62272 22.6082H9.56482C9.56482 23.5687 10.3433 24.3473 11.304 24.3473C11.304 25.3079 12.0825 26.0864 13.0431 26.0864H16.5214C17.4819 26.0864 18.2605 25.3079 18.2605 24.3473C19.221 24.3473 19.9997 23.5687 19.9997 22.6082H19.9418C20.9022 22.6082 21.7388 21.8296 21.7388 20.869Z"
        fill="#FFDA44"
      />
      <path
        d="M22.4534 18.0864L21.9969 18.8174L22.5507 19.4774L21.7145 19.2692L21.2578 19.9999L21.1976 19.1401L20.3613 18.9316L21.1606 18.6088L21.1005 17.749L21.6545 18.4093L22.4534 18.0864Z"
        fill="#FFDA44"
      />
      <path
        d="M19.7895 15.8506L19.6105 16.6936L20.3569 17.1245L19.4997 17.215L19.3205 18.0578L18.9699 17.2704L18.1128 17.3604L18.7533 16.7837L18.4029 15.9965L19.1491 16.4274L19.7895 15.8506Z"
        fill="#FFDA44"
      />
      <path
        d="M16.5214 14.6611L16.6413 15.5146L17.49 15.6643L16.7155 16.0421L16.8354 16.8956L16.2368 16.2756L15.4621 16.6534L15.8667 15.8924L15.2681 15.2725L16.1169 15.4221L16.5214 14.6611Z"
        fill="#FFDA44"
      />
      <path
        d="M13.0433 14.6611L13.448 15.4221L14.2967 15.2725L13.698 15.8925L14.1026 16.6535L13.3281 16.2756L12.7293 16.8954L12.8493 16.0421L12.0747 15.6643L12.9234 15.5146L13.0433 14.6611Z"
        fill="#FFDA44"
      />
      <path
        d="M9.77512 15.8506L10.4156 16.4274L11.1618 15.9965L10.8115 16.784L11.4518 17.3605L10.5948 17.2704L10.2441 18.0578L10.0652 17.2148L9.20801 17.1248L9.95426 16.6937L9.77512 15.8506Z"
        fill="#FFDA44"
      />
      <path
        d="M7.11127 18.0863L7.91057 18.4093L8.46424 17.749L8.40439 18.6089L9.20338 18.9318L8.36705 19.1401L8.30674 19.9998L7.85041 19.2691L7.01416 19.4775L7.56814 18.8173L7.11127 18.0863Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110822">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AzoresIslandsSvg;
